/* eslint-disable react/prop-types */
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function InfoDialog({
  isOpen,
  onClose,
  title = "View Details",
  children,
  button = true,
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader className={`flex justify-center items-center gap-2`}>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className=" w-full h-full">{children}</div>
        {button && (
          <DialogFooter>
            <div className={`flex w-full justify-center gap-5 items-center`}>
              <Button className="w-full bg-color14" onClick={onClose}>
                Cancel
              </Button>
            </div>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}
